import { render } from "./FiltersSidebar.vue?vue&type=template&id=78a06a2c&scoped=true"
import script from "./FiltersSidebar.vue?vue&type=script&lang=js"
export * from "./FiltersSidebar.vue?vue&type=script&lang=js"

import "./FiltersSidebar.vue?vue&type=style&index=0&id=78a06a2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a06a2c"]])

export default __exports__